module.exports = __webpack_public_path__ + "static/media/planet.e39b2553.svg";